module.exports = __webpack_public_path__ + "media/images/new_logo_white-5bb665592ab2c35d9b2180af26174b14.svg";